import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

// Register built-in validation rules
extend('required', {
    ...required,
    message: 'This field is required'
});

export default {
    install(Vue) {
        // Register VeeValidate components globally
        Vue.component('ValidationProvider', ValidationProvider);
        Vue.component('ValidationObserver', ValidationObserver);
    }
};
